<!--
  +---------------------------------------------------------------------------------------
  | @Copyright: Frippler Copyright (c)
  | @Title:     模型列表
  +---------------------------------------------------------------------------------------
-->

<template>
  <div class="dev-list" :class="{ 'is-collapse': collapse, 'fold': tagManagerFold }">
    <div class="tag-area" :class="!collapse&&'no-collapse'">
      <tag-manager ref="tagManager" v-model="query.tagid" type="dev" @toggle="handleTagManagerToggle"
        @change="fetchData(1)" @update="fetchData()" @delete="fetchData()">
      <div slot="tag-name">模型管理</div>
    </tag-manager>
    </div>
    <div class="table-area">
      <div class="filter-container">
        <div class="filter-box">
          <div class="filter-item sm">
            <el-select v-model="query.protocal" placeholder="协议类型" clearable @change="fetchData(1)" :style="{ width: 160 + 'px' }">
              <el-option
                v-for="(item, index) in protocalArr"
                :key="index"
                :label="item.protocal"
                :value="item.protocal">
              </el-option>
            </el-select>
          </div>

          <div v-if="aiot_version" class="filter-item">
            <ei-scheme-selector v-model="query.default_rms_schemeid" :show-unset="true" width="160px" @change="fetchData(1)" />
          </div>

          <div class="filter-item sm">
            <f-search-input v-model="query.keyword" width="160" placeholder="模型名称" prefix-icon="el-icon-search" clearable @change="fetchData(1)" />
          </div>
        </div>
        <div class="toolbox">
          <el-button v-if="dev_square_enable" type="primary" icon="iconfont icon-model-square" @click="plazaShow = true" plain>模型广场</el-button>
          <el-button icon="el-icon-plus" type="primary" @click="createDev">新建模型</el-button>
          <f-sort-selector v-model="query.sort" :options="sortOptions" class="ml-sm" @change="fetchData(1)" />
        </div>
      </div>
      <el-card v-loading="loading" shadow="never" class="card">
        <el-table ref="listTable" :data="list" :row-style="{ 'height': '61px' }" tooltip-effect="dark">
          <el-table-column width="60" type="index" label="#" />

          <el-table-column width="60">
            <template slot-scope="scope">             
              <el-image class="d-icon" :src="scope.row.avatar || require('@/assets/model.jpg')" :preview-src-list="scope.row.avatar ? [scope.row.avatar] : []" />
            </template>
          </el-table-column>

          <el-table-column label="模型名称" min-width="240" show-overflow-tooltip>
            <div slot-scope="scope">
              <div class="flex">
                <f-dev-name class="font-md" :dev="scope.row" />
                <tag-panel :ref="'tagPanel' + scope.row.devid" type="dev" :unique-key="scope.row.devid" :title="scope.row.dev_name" v-model="scope.row.tags" :tags="scope.row.tags" @update="handleTagPanelUpdate" />
              </div>
              <div v-if="scope.row.remark" class="text-muted font-sm" style="line-height: 17px;">{{ scope.row.remark }}
              </div>
            </div>
          </el-table-column>

          <el-table-column v-if="aiot_version" min-width="160" show-overflow-tooltip>
            <template slot="header" slot-scope="scope">
              <el-tooltip placement="top">
                <div slot="content">为模型设置收费方案后，加载该模型的设备将默认采用该收费方案作为远程服务的收费标准</div>
                <span>收费方案<i class="iconfont icon-circle-question text-muted ml-xs"></i></span>
              </el-tooltip>
            </template>
            <template slot-scope="scope">
              <el-popover
                v-if="scope.row.rms_schemeid || scope.row.default_rms_schemeid"
                placement="left"
                :width="scope.row.schemeList.length == 3 ? 300 : 110"
                trigger="hover"
                :open-delay="200">
                <div class="flex align-items-center" style="gap: 10px;">
                  <div v-for="(item,index) in scope.row.schemeList" :key="index" class="scheme_item" :class="(!scope.row.activity_enable || !scope.row.in_activity) && 'flex-center'">
                    <div v-if="scope.row.in_activity" class="flex column justify-content-center align-items-center text-black">
                      <div class="mt-sm text-bold">{{ item.title }}</div>
                      <div class="text-bold">￥{{ item.current_price }}</div>
                      <div v-if="item.origin_price != item.current_price" class="text-muted line-through pb" style="font-size: 11px;height: 17px;line-height: 17px">￥{{ item.origin_price }}</div>
                      <div v-else style="height: 17px" class="pb"></div>
                    </div>
                    <div v-else class="flex column justify-content-center align-items-center text-black">
                      <div class="mt-sm text-bold">{{ item.title }}</div>
                      <div class="text-bold">￥{{ item.origin_price }}</div>
                      <div style="height: 17px" class="pb"></div>
                    </div>
                    <div v-if="scope.row.activity_enable && scope.row.in_activity" class="discount flex-center">
                      <div v-if="item.discount" class="save ellipsis" style="font-size: 12px;">
                        已优惠<span>￥{{ item.discount }}</span>
                      </div>
                      <div v-else class="save ellipsis">
                        无优惠
                      </div>
                    </div>
                  </div>
                </div>
                <div slot="reference" role="button" @click="toScheme(scope.row)">
                  <span>{{ scope.row.rms_scheme_title }}</span>
                  <span class="ml-sm">{{ scope.row.rms_scheme_price | currency }}/年</span>
                </div>
              </el-popover>
              <el-button v-else type="text" class="hover-show" @click="toScheme(scope.row)">设置</el-button>
            </template>
          </el-table-column>

          <el-table-column label="设备数量" width="120" align="center">
            <template slot-scope="scope">
              <span class="font-lg">{{ scope.row.dev_total }}</span>
            </template>
          </el-table-column>
          <el-table-column width="20" />
          <el-table-column label="协议" width="120">
            <template slot-scope="scope">
              <span>{{ scope.row.protocal }}</span>
            </template>
          </el-table-column>

          <el-table-column label="创建时间" width="160">
            <template slot-scope="scope">
              <span>{{ scope.row.createtime | parseTime('{y}/{m}/{d} {h}:{i}') }}</span>
            </template>
          </el-table-column>

          <el-table-column label="更新时间" width="180">
            <template slot-scope="scope">
              <span>{{ scope.row.cmd_updatetime | parseTime('{y}/{m}/{d} {h}:{i}') }}</span>
              <el-tooltip v-if="scope.row.cmd_updatetime > scope.row.last_sync_time" placement="top">
                <div slot="content">
                  <span v-if="scope.row.last_sync_time">上次同步时间：{{ scope.row.last_sync_time | parseTime('{y}/{m}/{d} {h}: {i}') }}</span>
                  <span v-else>尚未同步</span>
                </div>
                <span class="ml-sm font-lg middle text-danger"><i class="iconfont icon-circle-warning-b" /></span>
              </el-tooltip>
            </template>
          </el-table-column>

          <el-table-column label="操作" width="120">
            <template slot-scope="scope">
              <f-dev-name type="button" :dev="scope.row" />
              <el-dropdown trigger="click" placement="bottom-start" class="ml-sm" >
                <el-button type="text">更多</el-button>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item @click.native="handleEdit(scope.row)">编辑</el-dropdown-item>
                  <el-dropdown-item @click.native="editDevRemark(scope.row)">备注</el-dropdown-item>
                  <el-dropdown-item @click.native="cloneDev(scope.row)">克隆</el-dropdown-item>
                  <el-dropdown-item @click.native="transfer(scope.row)">移交</el-dropdown-item>
                  <el-dropdown-item @click.native="deleteDev(scope.row)">删除</el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </template>
          </el-table-column>

          <template slot="append">
            <div class="foot-menu" :class="[!collapse && 'active', !tagManagerFold && 'fold']">
              <f-table-footer>
                <template slot="right">
                  <f-pagination :total="total" :pindex.sync="query.pindex" :psize.sync="query.psize"
                    @change="fetchData" />
                </template>
              </f-table-footer>
            </div>
          </template>

          <div slot="empty" class="flex-center column pb-md">
            <div class="flex-center mt-hg">
              <img src="../../assets/no-data.png" alt="" class="no-data">
            </div>
            <el-button type="warning" class="mt-xs" plain @click="toDoc">了解如何创建模型</el-button>
          </div>
        </el-table>
      </el-card>
    </div>


    <dev-creater v-if="devCreating" :show.sync="devCreating" @onSubmit="fetchData(1)" />
    <dev-clone v-if="cloning" :show.sync="cloning" :devid="activeDev.devid" :dev-name="activeDev.dev_name" @onSubmit="fetchData(1)" />
    <dev-plaza v-if="plazaShow" :show.sync="plazaShow" @clone="fetchData(1)" />
    <dev-edit v-if="editShow" :show.sync="editShow" :devid="activeDev.devid" @onSubmit="fetchData(1)" />
    <dev-transfer v-if="transferShow" :show.sync="transferShow" :row="activeDev" :devid="activeDev.devid" @success="fetchData(1)" />
    <default-dev-dialog v-if="defaultDevDialogShow" :show.sync="defaultDevDialogShow" />

    <dev-scheme v-if="schemeShow" :show.sync="schemeShow" :dev="activeDev" @success="fetchData" />
  </div>
</template>

<script>
import { getDevListApi, deleteDevApi, editDevProfileApi } from "@/api/dev/devApi";

export default {
  name: "DevList",

  components: {
    TagManager: () => import("@/views/fam/components/TagManager"),
    TagPanel: () => import("@/views/fam/components/TagPanel2"),
    DevCreater: () => import("@/views/dev/components/DevCreater"),
    DevClone: () => import("@/views/dev/components/DevClone"),
    DevEdit: () => import("@/views/dev/components/DevEdit"),
    DevPlaza: () => import("./components/DevPlaza.vue"),
    DevTransfer: () => import("./components/DevTransfer.vue"),
    DefaultDevDialog: () => import("./components/DefaultDevDialog"),
    DevScheme: () => import("./components/DevScheme.vue"),
    EiSchemeSelector: () => import('@/views/ei/components/EiSchemeSelector'),
  },

  data() {
    return {
      time: parseInt(new Date().valueOf() / 1000),
      schemeShow: false,
      plazaShow: false,
      sortOptions: [
        { value: 0, title: "最近创建" },
        { value: 5, title: "最近更新" },
        { value: 7, title: "最多设备" },
        { value: 2, title: "按名称 A-Z" },
        { value: 3, title: "按名称 Z-A" }
      ],
      loading: false,
      query: {
        tagid: 0,
        keyword: "",
        sort: null,
        pindex: 1,
        psize: this.$store.state.commonStore.psize
      },
      list: [],
      total: 0,

      version_limit: {
        aiot_version: 0,
        dev_total: 0,
        dev_upper_limit: 0
      },

      tagManagerFold: Number(localStorage.getItem(`__TAG_MANAGER_FOLD_DEV__`)),

      devCreating: false,

      cloning: false,
      editShow: false,
      clonedDevid: undefined,
      activeDev: {
        devid: undefined
      },
      protocalArr: [
      {
        protocal: "MBRTU",
      },{
        protocal: "MQTT",
      }
      ],
      transferShow: false,
      defaultDevDialogShow: false,
    };
  },

  computed: {
    collapse() {
      return this.$store.state.commonStore.collapse
    },

    aiot_version() {
      return this.$store.state.godStore.aiot_version
    },

    dev_square_enable() {
      return this.$store.state.godStore.dev_square_enable
    }
  },

  created() {
    this.query = this.$utils.initListQuery(this.query, ["/dev/detail"]);
    this.fetchData();
  },

  beforeRouteLeave(to, from, next) {
    this.$utils.saveListQuery(this.query);
    next();
  },

  methods: {

    toScheme(dev) {
      this.activeDev = Object.assign({}, dev)
      this.schemeShow = true
    },

    devchange(dev) {
    },

    fetchData(page,loading = true) {
      if (page) this.query.pindex = page;
      if(loading) this.loading = true;
      getDevListApi(this.query).then(res => {
        this.loading = false;
        if (res.errno === 0) {
          var list = []
          if(res.data.list.length > 0) {
            list = res.data.list.map(item => {
              if (!item.rms_schemeid && !item.default_rms_schemeid) return item
              item.price = item.rms_scheme_price
              let one_year_obj = {}
              let two_year_obj = {}
              let three_year_obj = {}

              if(item.activity_enable && item.activity_params.advanced_price_enable) {
                one_year_obj = Object.assign({},{
                  title: '1年',
                  price: +(item.price).toFixed(2),
                  origin_price: +(item.price).toFixed(2),
                  current_price: +(item.activity_params.advanced_prices.one_year).toFixed(2), 
                  discount: +(item.price - item.activity_params.advanced_prices.one_year).toFixed(2)
                })
                two_year_obj = Object.assign({},{
                  title: '2年',
                  price: +(item.price).toFixed(2),
                  origin_price: +(item.price * 2).toFixed(2),
                  current_price: +(item.activity_params.advanced_prices.two_year * 2).toFixed(2), 
                  discount: +(item.price - item.activity_params.advanced_prices.two_year) * 2
                })
                three_year_obj = Object.assign({},{
                  title: '3年',
                  price: +(item.price).toFixed(2),
                  origin_price: +(item.price * 3).toFixed(2),
                  current_price: +(item.activity_params.advanced_prices.three_year * 3).toFixed(2),
                  discount: +((item.price - item.activity_params.advanced_prices.three_year) * 3).toFixed(2)
                })
                one_year_obj.discount = one_year_obj.discount === Math.floor(one_year_obj.discount) ? one_year_obj.discount : one_year_obj.discount.toFixed(2)
                two_year_obj.discount = two_year_obj.discount === Math.floor(two_year_obj.discount) ? two_year_obj.discount : two_year_obj.discount.toFixed(2)
                three_year_obj.discount = three_year_obj.discount === Math.floor(three_year_obj.discount) ? three_year_obj.discount : three_year_obj.discount.toFixed(2)
                item.schemeList = [].concat(one_year_obj, two_year_obj, three_year_obj)
              } else if (item.activity_enable) {
                one_year_obj = Object.assign({},{ 
                  title: '1年',
                  price: +(item.price).toFixed(2),
                  origin_price: +(item.price).toFixed(2),
                  current_price: +(item.activity_params.discount_price).toFixed(2), 
                  discount: +(item.price - item.activity_params.discount_price).toFixed(2)
                })
                two_year_obj = Object.assign({},{ 
                  title: '2年',
                  price: +(item.price).toFixed(2),
                  origin_price: +(item.price * 2).toFixed(2),
                  current_price: +(item.activity_params.discount_price * 2).toFixed(2), 
                  discount: +((item.price - item.activity_params.discount_price) * 2).toFixed(2)
                })
                three_year_obj = Object.assign({},{
                  title: '3年',
                  price: +(item.price).toFixed(2),
                  origin_price: +(item.price * 3).toFixed(2),
                  current_price: +(item.activity_params.discount_price * 3).toFixed(2),
                  discount: +((item.price - item.activity_params.discount_price) * 3).toFixed(2)
                })
                one_year_obj.discount = one_year_obj.discount === Math.floor(one_year_obj.discount) ? one_year_obj.discount : one_year_obj.discount.toFixed(2)
                two_year_obj.discount = two_year_obj.discount === Math.floor(two_year_obj.discount) ? two_year_obj.discount : two_year_obj.discount.toFixed(2)
                three_year_obj.discount = three_year_obj.discount === Math.floor(three_year_obj.discount) ? three_year_obj.discount : three_year_obj.discount.toFixed(2)
                item.schemeList = [].concat(one_year_obj, two_year_obj, three_year_obj)
              } else {
                one_year_obj = Object.assign({},{
                  title: '1年',
                  price: +(item.price).toFixed(2),
                  origin_price: +(item.price).toFixed(2),
                  current_price: +(item.price).toFixed(2), 
                  discount: 0
                })
                two_year_obj = Object.assign({},{
                  title: '2年',
                  price: +(item.price).toFixed(2),
                  origin_price: +(item.price * 2).toFixed(2),
                  current_price: +(item.price * 2).toFixed(2), 
                  discount: 0
                })
                three_year_obj = Object.assign({},{
                  title: '3年',
                  price: +(item.price).toFixed(2),
                  origin_price: +(item.price * 3).toFixed(2),
                  current_price: +(item.price * 3).toFixed(2),
                  discount: 0
                })
                item.schemeList = [].concat(one_year_obj, two_year_obj, three_year_obj)
              }
              item.in_activity = item.activity_params.starttime
                ? this.time > item.activity_params.starttime &&
                  this.time < item.activity_params.endtime
                : false;
              if((item.activity_enable && !item.activity_params.advanced_price_enable) || !item.activity_enable) {
                item.schemeList = item.schemeList.splice(0, 1)
              }
              if(item.schemeList.some(schemeItem => schemeItem.price >= 200)) {
                item.show_tip = true
              } else {
                item.show_tip = false
              }
              return item
            })
          }
          this.list = list
          this.total = res.data.total;
          this.query.sort = res.data.sort
          this.version_limit = Object.assign({}, res.data.version_limit)
        }
      });
    },


    createDev() {
      if (this.$store.state.godStore.certified !== 1) {
        this.$fCertifiedConfirm({
          onConfirm: () => {
            this.$router.push("/fam/certify")
          }
        })
        return
      }
      if (this.version_limit.aiot_version == 0  && this.version_limit.dev_total >= this.version_limit.dev_upper_limit) {
        this.$message.error('免费版AIOT用户支持新建最多' + this.version_limit.dev_upper_limit + '个模型，如需建更多模型请升级版本')
        return
      }
      this.devCreating = true;
    },

    cloneDev(dev) {
      if (this.$store.state.godStore.certified !== 1) {
        this.$fCertifiedConfirm({
          onConfirm: () => {
            this.$router.push("/fam/certify")
          }
        })
        return
      }
      this.activeDev = Object.assign({}, dev);
      this.cloning = true;
    },

    transfer(dev) {
      this.transferShow = true;
      this.activeDev = Object.assign({}, dev);
    },

    deleteDev(dev) {
      const msg = `即将删除模型 <span class="text-danger">${
        dev.dev_name
      }</span>，删除后不可恢复，是否继续？`;
      this.$confirm(msg, "操作确认", {
        type: "error",
        dangerouslyUseHTMLString: true
      })
        .then(() => {
          deleteDevApi([dev.devid]).then(res => {
            if (!res.errno) {
              this.$message.success(res.message);
              this.fetchData(1);
            } else {
              this.$message.error(res.message);
            }
          });
        })
        .catch(() => {
          // 取消
        });
    },

    handleEdit(row) {
      this.activeDev = Object.assign({}, row);
      this.editShow = true;
    },

    editDevRemark(row) {
      this.$prompt(`请输入备注信息`, row.dev_name, {
        inputValue: row.remark,
        closeOnClickModal: false
      })
        .then(({ value }) => {
          editDevProfileApi({ devid: row.devid, remark: value }).then((res) => {
            if (!res.errno) {
              this.fetchData();
            } else {
              this.$message.error(res.message);
            }
          });
        })
        .catch(() => {
          // 取消
        });
    },

    handleTagManagerToggle(val) {
      this.tagManagerFold = val;
    },
    handleTagPanelUpdate() {
      this.fetchData(this.query.pindex, false);
      this.$refs["tagManager"].fetchData();
    },

    toDevDetail(devid) {
      this.$router.push("/dev/detail?devid=" + devid);
    },

    toDoc() {
      window.open("https://wiki.frippler.com/#/docs/fs/fcs/22");
    },

    showDefaultModel() {
      this.defaultDevDialogShow = true;

    },
  }
};
</script>

<style lang="scss" scoped>
.dev-list {
  .tag-area {
    position: fixed;
    top: 60px;
    left: 160px;
    width: 240px;
    height: calc(100% - 60px);
    background-color: #fff;
    &.no-collapse {
      border-bottom-left-radius: 20px;
    }
  }

  .table-area {
    padding-left: 240px;
    padding-bottom: 60px;
    /deep/ .card {
      margin-bottom: 20px;
      border: none;
    }
    .custom-button {
      width: 200px;
      height: 36px;
      border-radius: 5px;
      background: linear-gradient(89.45deg, rgba(186,232,248,1) 0.07%,rgba(234,244,255,1) 74.99%);
      color: rgba(64,158,255,1);
      font-size: 14px;
      text-align: left;
      box-shadow: 0px 2px 6px 0px rgba(0,0,0,0.1);
      padding: 0 10px;
      cursor: pointer;
    }
  }

  &.fold {
    .tag-area {
      width: 60px;
    }

    .table-area {
      padding-left: 60px;
    }
  }

  &.is-collapse {
    .tag-area {
      left: 60px;
    }
  }
}
/deep/ .sort {
  width: 80px;
}
.no-data {
  width: 200px;
  height: 200px;
}
.d-icon {
  font-size: 40px;
  line-height: 40px;
  width: 40px;
  height: 40px;
  border-radius: 10%;
}
.foot-menu {
  position: fixed;
  background-color: #fff;
  bottom: 0;
  left: 120px;
  width: calc(100% - 120px);
  z-index: 3;
  padding-left: 20px;
  padding: 4px 30px 5px 20px;

  &.active {
    left: 220px;
    width: calc(100% - 220px);
  }

  &.fold {
    left: 300px;
    width: calc(100% - 300px);
  }

  &.active.fold {
    left: 400px;
    width: calc(100% - 400px);
  }

  .f-table-footer {
    margin: 0;
    height: 50px;
  }
}
.scheme_item {
  width: 90px;
  height: 105px;
  border-radius: 5px;
  position: relative;
  font-size: 14px;
  background-color: rgba(255,255,255,1);
  border: 1px solid rgba(237,237,237,1);
  .discount {
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 24px;
    line-height: 24px;
    background-color: rgba(7,193,96,0.4);
    color: rgba(7,193,96,1);
    font-size: 13px;
    text-align: center;
    border-radius: 0 0 5px 5px;
  }
}
</style>
